// Network mocking is dev-only and opt-in, so it can never reach a deployed build.
const mocksEnabled =
  process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_ENABLE_MSW === "true";

const bootstrap = () => import("./bootstrap.tsx");

if (mocksEnabled) {
  import("./mocks/browser")
    // Start the worker before the app boots, so its first requests are intercepted.
    .then(({ startMockServiceWorker }) => startMockServiceWorker())
    .catch((error) =>
      // Boot unmocked rather than leaving a blank screen - but say so loudly,
      // because the app is now calling the real APIs.
      console.error(
        "[msw] Mocking failed to start, booting against the real APIs instead. Expect CORS and auth failures.",
        error,
      ),
    )
    .then(bootstrap);
} else {
  bootstrap();
}
